import React, { useEffect, useMemo, useRef, useState } from 'react';
import './App.css';
import 'leaflet/dist/leaflet.css';
import { MapContainer, TileLayer, Marker, Popup, useMap } from 'react-leaflet';
import L from 'leaflet';
import Flatpickr from 'react-flatpickr';
import 'flatpickr/dist/themes/airbnb.css';
import { Polish } from 'flatpickr/dist/l10n/pl.js';
import Select from 'react-select';
import { useDebounce } from "./useDebounce";
import { useSearchParams } from "react-router-dom";
import { Routes, Route } from "react-router-dom";
import Login from "./pages/Login";
import Register from "./pages/Register";
import Profile from "./pages/Profile";
import MainPage from "./pages/MainPage";
import PublicProfile from "./pages/PublicProfile";
import EventPage from "./pages/EventPage";
import CityRedirect from "./components/CityRedirect";
import AccountSettingsPage from './pages/AccountSettingsPage';
import AuthModal from './auth/AuthModal';
import ResetPasswordRoute from "./components/ResetPasswordRoute";
import AboutPage from "./pages/AboutPage";
import RegulaminSerwisuPage from "./pages/RegulaminSerwisuPage";
import RedirectToPdf from "./components/RedirectToPdf";
import ConfirmMailRoute from "./components/ConfirmMailRoute";

// Sprawdza, czy URI do obrazka jest aktywne
async function validateImageURL(url) {
  if (!url) return false;
  return new Promise((resolve) => {
    const img = new Image();
    img.onload = () => resolve(true);
    img.onerror = () => resolve(false);
    img.src = url;
  });
}

function ExpandableSection({ isOpen, children }) {
  const contentRef = React.useRef(null);

  return (
    <div
      className={`expandable-section ${isOpen ? 'open' : ''}`}
      style={{
        transform: isOpen ? 'scaleY(1)' : 'scaleY(0)',
        opacity: isOpen ? 1 : 0,
      }}
    >
      <div ref={contentRef} className="expandable-inner">
        {children}
      </div>
    </div>
  );
}



const CITY_CENTER = [52.2297, 21.0122]; // Warszawa

const markerColorByTags = (tags = []) => {
  if (tags.includes('Imprezy')) return '#e93598ff';
  if (tags.includes('Muzyka')) return '#e91c1cff';
  if (tags.includes('Film')) return '#00c6ff';
  if (tags.includes('Targi')) return '#00d68f';
  if (tags.includes('Rodzinne')) return '#f9cc45';
  return '#94d0f8ff';
};

const divIconFor = (color = '#888') =>
  L.divIcon({
    className: 'custom-marker',
    html: `<div class="pulse" style="width:20px;height:20px;background:${color};border-radius:50%;border:3px solid white;box-shadow:0 6px 18px rgba(0,0,0,.2)"></div>`,
    iconSize: [20, 20],
    iconAnchor: [10, 10],
  });

function MapFly({ center }) {
  const map = useMap();
  useEffect(() => {
    if (center) map.flyTo(center, 12, { duration: 0.5 });
  }, [center, map]);
  return null;
}

const toYMD = (d) => {
  if (!d || isNaN(d.getTime())) return '';
  const pad = (n) => String(n).padStart(2, '0');
  return `${d.getFullYear()}-${pad(d.getMonth()+1)}-${pad(d.getDate())}`;
};

// export default function App() {
//   const [events, setEvents] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [query, setQuery] = useState('');
//   const [selected, setSelected] = useState(null);
//   const [planned, setPlanned] = useState(() => JSON.parse(localStorage.getItem('planned') || '[]'));
//   const [theme, setTheme] = useState(() => localStorage.getItem('theme') || (window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light'));
//   const [dateFrom, setDateFrom] = useState('');
//   const [dateTo, setDateTo] = useState('');
//   // const [category, setCategory] = useState(null);
//   const [sort, setSort] = useState('soon');
//   const [expandedEvent, setExpandedEvent] = useState(null);
//   const [priceFilters, setPriceFilters] = useState({
//     free: 'free',
//     paid: 'paid',
//   });
//   const [filtersExpanded, setFiltersExpanded] = useState(window.innerWidth > 992);
//   const [isCompact, setIsCompact] = useState(window.innerWidth < 992);
//   const [showEventsList, setShowEventsList] = useState(true);
//   const [windowWidth, setWindowWidth] = useState(window.innerWidth);
//   const [categories, setCategories] = useState([]);
//   // const [selectedCategories, setSelectedCategories] = useState(null);
//   // const [categoryDropdownOpen, setCategoryDropdownOpen] = useState(false);
//   const markerRefs = useRef({}); // przechowuje referencje do markerów
//   const debouncedQuery = useDebounce(query, 400);
//   const [searchParams, setSearchParams] = useSearchParams();

//   const handleSelectEvent = (eventId) => {
//     setSelected(eventId);

//     const marker = markerRefs.current[eventId];
//     if (marker) {
//       const map = marker._map;
//       const { lat, lng } = marker.getLatLng();

//       map.flyTo([lat, lng], 14, { duration: 0.6 }); // zoomuj i przesuń
//       marker.openPopup(); // otwórz popup
//     }

//     // przewiń listę
//     setTimeout(() => {
//       document.getElementById(`event-${eventId}`)?.scrollIntoView({
//         behavior: "smooth",
//         block: "start",
//       });
//     }, 300);
//   };
  
//   const catergoryOptions = [
//     { value: "apple", label: "Jabłko" },
//     { value: "banana", label: "Banan" },
//     { value: "orange", label: "Pomarańcza" },
//     { value: "kiwi", label: "Kiwi" },
//   ];

//   const [selectedCategories, setSelectedCategories] = useState([]);

//   useEffect(() => {
//     fetch("/api/categories/")
//       .then((res) => res.json())
//       .then((data) => {
//         const formatted = data.map(cat => ({
//           value: cat.name || cat.id || cat, // zależnie od struktury API
//           label: cat.display_name || cat.name || cat
//         }));
//         setCategories(formatted);
//       })
//       .catch((err) => console.error("Błąd pobierania kategorii:", err));
//   }, []);

  

//   useEffect(() => {
//     const handleResize = () => {
//       setWindowWidth(window.innerWidth);

//       if (window.innerWidth >= 992) {
//         // duży ekran → lista zawsze widoczna
//         setShowEventsList(true);
//       } else {
//         // mały ekran → lista powinna być skrócona domyślnie
//         setShowEventsList(false);
//       }
//       // sterowanie kompaktowym paskiem filtrów
//       setIsCompact(window.innerWidth <= 992); // lub 1200, jeśli chcesz wcześniejsze zwijanie
//       // automatyczne zwinięcie filtrów, gdy ekran się zmniejsza
//       if (window.innerWidth <= 992) {
//         setFiltersExpanded(false);
//     }
//     };

//     window.addEventListener('resize', handleResize);

//     // Ustaw odpowiedni stan przy pierwszym renderze
//     if (window.innerWidth >= 992) {
//       setShowEventsList(true);
//     } else {
//       setShowEventsList(false);
//     }

//     return () => window.removeEventListener('resize', handleResize);
//   }, []);


//   const toggleTheme = () => {
//     const next = theme === 'light' ? 'dark' : 'light';
//     document.documentElement.setAttribute('data-bs-theme', next);
//     localStorage.setItem('theme', next);
//     setTheme(next);
//   };

//   useEffect(() => {
//     document.documentElement.setAttribute('data-bs-theme', theme);
//   }, [theme]);

//   // useEffect(() => {
//   //   (async () => {
//   //     try {
//   //       setLoading(true);
//   //       const res = await fetch('/api/events/top100/');
//   //       const data = await res.json();
//   //       const mapped = await Promise.all(
//   //         data.map(async (e, idx) => {
//   //           const lat = parseFloat(e.event_place_latitude);
//   //           const lng = parseFloat(e.event_place_longitude);
//   //           let cover = e.event_photo_uri || '';

//   //           // Uzupełnij względny URL (jeśli zaczyna się od "/")
//   //           if (cover && !cover.startsWith('http')) {
//   //             cover = `${window.location.origin}${cover}`;
//   //           }

//   //           // Sprawdź, czy URL jest aktywny
//   //           const valid = await validateImageURL(cover);
//   //           if (!valid) {
//   //             cover = 'https://images.unsplash.com/photo-1511379938547-c1f69419868d?q=80&w=1200&auto=format&fit=crop';
//   //           }
//   //           const primary = e.primary_category?.trim() || null;
//   //           const tops = (e.top_categories || '')
//   //             .split(',')
//   //             .map((t) => t.trim())
//   //             .filter(Boolean);

//   //           // Usuń duplikaty i zachowaj kolejność
//   //           const tags = [...new Set([...(primary ? [primary] : []), ...tops])];

//   //           return {
//   //             id: e.event_internal_id || idx,
//   //             title: e.event_name || 'Bez nazwy',
//   //             place: e.event_venue || e.one_line_address || '',
//   //             date: e.event_start_date || '',
//   //             popularity: parseInt(e.interested_people_count || 0),
//   //             link: e.event_link || '',
//   //             primary,
//   //             tags,
//   //             coords: Number.isFinite(lat) && Number.isFinite(lng) ? [lat, lng] : null,
//   //             cover,
//   //             isFree: e.is_free === 'free' || e.is_free === true,
//   //             price: e.price_info || '',
//   //             organizer: e.creator_name || '',
//   //             organizer_link: e.creator_link || '',
//   //             description: e.event_description || '',
//   //           };
//   //         })
//   //       );
//   //       setEvents(mapped);
//   //     } catch (err) {
//   //       console.error(err);
//   //     } finally {
//   //       setLoading(false);
//   //     }
//   //   })();
//   // }, []);

//   useEffect(() => {
//   (async () => {
//     try {
//       setLoading(true);

//       // --- 1️⃣ Budujemy parametry ---
//       const params = new URLSearchParams();

//       if (debouncedQuery) params.append("q", debouncedQuery);
      

//       // Kategorie (może być wiele)
//       if (selectedCategories.length > 0) {
//         const categoryValues = selectedCategories.map((c) => c.value || c).join(",");
//         params.append("category", categoryValues);
//       }

//       // Cena (może być kilka)
//       const selectedPriceFilters = [];
//       if (priceFilters.free) selectedPriceFilters.push("free");
//       if (priceFilters.paid) selectedPriceFilters.push("paid");
//       if (selectedPriceFilters.length > 0) {
//         params.append("is_free", selectedPriceFilters.join(","));
//       }

//       // Daty
//       if (dateFrom) params.append("date_from", dateFrom);
//       if (dateTo) params.append("date_to", dateTo);

//       // Sortowanie
//       params.append("sort", sort);

//       setSearchParams(params);

//       // --- 2️⃣ Zapytanie do backendu ---
//       const res = await fetch(`/api/events/top100/?${params.toString()}`);
//       const data = await res.json();

//       // --- 3️⃣ Mapowanie danych ---
//       const mapped = await Promise.all(
//         data.map(async (e, idx) => {
//           const lat = parseFloat(e.event_place_latitude);
//           const lng = parseFloat(e.event_place_longitude);
//           let cover = e.event_photo_uri || "";

//           if (cover && !cover.startsWith("http")) {
//             cover = `${window.location.origin}${cover}`;
//           }

//           // sprawdź, czy URL działa
//           const valid = await validateImageURL(cover);
//           if (!valid) {
//             cover =
//               "https://images.unsplash.com/photo-1511379938547-c1f69419868d?q=80&w=1200&auto=format&fit=crop";
//           }

//           const primary = e.primary_category?.trim() || null;
//           const tops = (e.top_categories || "")
//             .split(",")
//             .map((t) => t.trim())
//             .filter(Boolean);

//           const tags = [...new Set([...(primary ? [primary] : []), ...tops])];

//           return {
//             id: e.event_internal_id || idx,
//             title: e.event_name || "Bez nazwy",
//             place: e.event_venue || e.one_line_address || "",
//             date: e.event_start_date || "",
//             popularity: parseInt(e.interested_people_count || 0),
//             link: e.event_link || "",
//             primary,
//             tags,
//             coords:
//               Number.isFinite(lat) && Number.isFinite(lng) ? [lat, lng] : null,
//             cover,
//             isFree: e.is_free === "free" || e.is_free === true,
//             price: e.price_info || "",
//             organizer: e.creator_name || "",
//             organizer_link: e.creator_link || "",
//             description: e.event_description || "",
//           };
//         })
//       );

//       setEvents(mapped);
//     } catch (err) {
//       console.error(err);
//     } finally {
//       setLoading(false);
//     }
//   })();
// }, [debouncedQuery,selectedCategories, priceFilters, dateFrom, dateTo, sort]);

//   const filtered = useMemo(() => {
//   let out = events.slice();

//   // const q = query.trim().toLowerCase();
//   // if (q) {
//   //   out = out.filter(
//   //     (e) =>
//   //       e.title.toLowerCase().includes(q) ||
//   //       e.place.toLowerCase().includes(q) ||
//   //       e.tags.some((t) => t.toLowerCase().includes(q))
//   //   );
//   // }

//   if (selectedCategories.length > 0) {
//   const selectedValues = selectedCategories.map(c => c.value);
//   out = out.filter(e =>
//     e.primary && selectedValues.includes(e.primary)
//   );
// }

//   if (dateFrom) {
//     const from = new Date(dateFrom);
//     out = out.filter((e) => new Date(e.date) >= from);
//   }

//   if (dateTo) {
//     const to = new Date(dateTo);
//     out = out.filter((e) => new Date(e.date) <= to);
//   }

//   if (priceFilters.free && !priceFilters.paid) {
//     out = out.filter((e) => e.isFree);
//   } else if (!priceFilters.free && priceFilters.paid) {
//     out = out.filter((e) => !e.isFree);
//   }

//   if (sort === 'soon') {
//     out.sort((a, b) => new Date(a.date) - new Date(b.date));
//   } else if (sort === 'popular') {
//     out.sort((a, b) => (b.popularity || 0) - (a.popularity || 0));
//   } else if (sort === 'new') {
//     out.sort((a, b) => new Date(b.date) - new Date(a.date));
//   }

  

//   return out;
// }, [events, query, selectedCategories, dateFrom, dateTo, priceFilters,sort]);

//   const markers = filtered.filter((e) => e.coords);
//   const selectedCoord = selected
//     ? filtered.find((e) => e.id === selected)?.coords
//     : markers[0]?.coords || CITY_CENTER;

//   const isPlanned = (id) => planned.includes(id);
//   const togglePlan = (id) => {
//     setPlanned((prev) => {
//       const next = prev.includes(id) ? prev.filter((x) => x !== id) : [...prev, id];
//       localStorage.setItem('planned', JSON.stringify(next));
//       return next;
//     });
//   };

//   useEffect(() => {
//   const q = searchParams.get("q") || "";
//   const category = (searchParams.get("category") || "")
//     .split(",")
//     .filter(Boolean)
//     .map((c) => ({ value: c, label: c }));

//   const is_free = (searchParams.get("is_free") || "").split(",");
//   const date_from = searchParams.get("date_from") || "";
//   const date_to = searchParams.get("date_to") || "";
//   const sortParam = searchParams.get("sort") || "popular";

//   setQuery(q);
//   setSelectedCategories(category);
//   setPriceFilters({
//     free: is_free.includes("free"),
//     paid: is_free.includes("paid"),
//   });
//   setDateFrom(date_from);
//   setDateTo(date_to);
//   setSort(sortParam);
// }, []);


//   return (
//     <div className="app d-flex flex-column min-vh-100">
//       {/* NAVBAR */}
//       <nav className="navbar navbar-expand-lg glass sticky-top shadow-sm px-3">
//         <div className="container-fluid">
//           <span className="navbar-brand fw-bold fs-4 text-gradient">
//             <i className="bi bi-stars me-2 text-primary"></i>
//             <span className="brand-gradient">Sie<span className="text-body">Dzieje</span></span>
//           </span>
//           <div className="d-flex align-items-center gap-3">
//             <button
//               className="btn btn-outline-secondary btn-sm"
//               onClick={toggleTheme}
//               title="Przełącz tryb jasny/ciemny"
//             >
//               {theme === 'light' ? (
//                 <i className="bi bi-moon-stars"></i>
//               ) : (
//                 <i className="bi bi-sun"></i>
//               )}
//             </button>
//             <button className="btn btn-primary btn-sm">
//               <i className="bi bi-calendar2-check me-1"></i> Plan
//             </button>
//           </div>
//         </div>
//       </nav>

//       {/* FILTRY */}
//       {/* === PANEL FILTRÓW === */}
//       <div className="filters glass border-bottom py-3">
//         <div className="container d-flex flex-wrap align-items-center justify-content-start gap-3 filter-row sticky top-0 py-2">

//           {/* Searchbar */}
//           <div className="modern-search flex-shrink-0">
//             <i className="bi bi-search"></i>
//             <input
//               type="text"
//               placeholder="Szukaj wydarzeń..."
//               value={query}
//               onChange={(e) => setQuery(e.target.value)}
//             />
//             {query && (
//               <button onClick={() => setQuery('')}>
//                 <i className="bi bi-x-lg"></i>
//               </button>
//             )}
//           </div>
          
//           {isCompact ? (
//             // na wąskim ekranie pokazuj je tylko w panelu rozwijanym
//             null
//           ) : (
//             <>
//               {/* Kalendarz */}
//               <div className="modern-date-range">
//                 <div className="date-range-wrap">
//                   <i className="bi bi-calendar2-range"></i>
//                   <Flatpickr
//                     options={{
//                       mode: 'range',
//                       dateFormat: 'Y-m-d',
//                       altInput: true,
//                       altFormat: 'd M Y',
//                       allowInput: true,
//                       locale: Polish,
//                     }}
//                     value={[
//                       dateFrom ? new Date(dateFrom) : null,
//                       dateTo ? new Date(dateTo) : null,
//                     ].filter(Boolean)}
//                     onChange={(selectedDates /* array<Date> */) => {
//                       if (selectedDates.length === 0) {
//                         setDateFrom('');
//                         setDateTo('');
//                       } else if (selectedDates.length === 1) {
//                         setDateFrom(toYMD(selectedDates[0]));
//                         setDateTo('');
//                       } else {
//                         const [start, end] = selectedDates;
//                         setDateFrom(toYMD(start));
//                         setDateTo(toYMD(end));
//                       }
//                     }}
//                     className="flatpickr-input-custom"
//                     placeholder="Zakres dat: Od – Do"
//                   />
//                   {(dateFrom || dateTo) && (
//                     <button
//                       type="button"
//                       className="btn-clear-date"
//                       title="Wyczyść zakres"
//                       onClick={() => { setDateFrom(''); setDateTo(''); }}
//                     >
//                       <i className="bi bi-x-lg"></i>
//                     </button>
//                   )}
//                 </div>
//               </div>

//               {/* Sortowanie */}
//               <div className="modern-sort flex-shrink-0">
//                 <i className="bi bi-filter-circle me-1"></i>
//                 <select
//                   value={sort}
//                   onChange={(e) => setSort(e.target.value)}
//                 >
//                   <option value="soon">Najszybciej</option>
//                   <option value="popular">Najpopularniejsze</option>
//                   <option value="new">Najnowsze</option>
//                 </select>
//               </div>
//             </>
//           )}
//           {/* Przycisk rozwijania */}
//           <button
//             className="btn btn-outline-primary rounded-pill btn-sm flex-shrink-0 d-flex align-items-center gap-1"
//             onClick={() => setFiltersExpanded((prev) => !prev)}
//           >
//             <i className={`filter-button bi ${filtersExpanded ? 'bi-chevron-up' : 'bi-chevron-down'}`}></i>
//             {filtersExpanded ? 'Zwiń filtry' : 'Więcej filtrów'}
//           </button>
//         </div>

//         {/* Rozwijany panel */}
//         <div
//           className={`filters-expanded ${filtersExpanded ? 'open' : ''}`}
//           style={{
//             maxHeight: filtersExpanded ? '400px' : '0px',
//             opacity: filtersExpanded ? 1 : 0,
//             overflow: filtersExpanded ? 'visible' : 'hidden',
//             transition: 'max-height 0.4s ease, opacity 0.3s ease',
//             position: 'relative', // pomoże z pozycjonowaniem menu
//             zIndex: 10,
//           }}
//         >
//           <div className="container mt-3 d-flex flex-wrap align-items-center gap-3 overflow-visible">
            
//             {isCompact && (
//             <>
//               {/* Kalendarz */}
//               <div className="modern-date-range">
//                 <div className="date-range-wrap">
//                   <i className="bi bi-calendar2-range"></i>
//                   <Flatpickr
//                     options={{
//                       mode: 'range',
//                       dateFormat: 'Y-m-d',
//                       altInput: true,
//                       altFormat: 'd M Y',
//                       allowInput: true,
//                       locale: Polish,
//                     }}
//                     value={[
//                       dateFrom ? new Date(dateFrom) : null,
//                       dateTo ? new Date(dateTo) : null,
//                     ].filter(Boolean)}
//                     onChange={(selectedDates /* array<Date> */) => {
//                       if (selectedDates.length === 0) {
//                         setDateFrom('');
//                         setDateTo('');
//                       } else if (selectedDates.length === 1) {
//                         setDateFrom(toYMD(selectedDates[0]));
//                         setDateTo('');
//                       } else {
//                         const [start, end] = selectedDates;
//                         setDateFrom(toYMD(start));
//                         setDateTo(toYMD(end));
//                       }
//                     }}
//                     className="flatpickr-input-custom"
//                     placeholder="Zakres dat: Od – Do"
//                   />
//                   {(dateFrom || dateTo) && (
//                     <button
//                       type="button"
//                       className="btn-clear-date"
//                       title="Wyczyść zakres"
//                       onClick={() => { setDateFrom(''); setDateTo(''); }}
//                     >
//                       <i className="bi bi-x-lg"></i>
//                     </button>
//                   )}
//                 </div>
//               </div>

//               {/* Sortowanie */}
//               <div className="modern-sort flex-shrink-0">
//                 <i className="bi bi-filter-circle me-1"></i>
//                 <select
//                   value={sort}
//                   onChange={(e) => setSort(e.target.value)}
//                 >
//                   <option value="soon">Najszybciej</option>
//                   <option value="popular">Najpopularniejsze</option>
//                   <option value="new">Najnowsze</option>
//                 </select>
//               </div>
//             </>
//           )}

//             {/* Kategorie */}
//             <div className="category-filter">
//             {/* <label className="form-label mb-1 fw-semibold">Kategorie:</label> */}
//             <Select
//               isMulti
//               options={categories}
//               value={selectedCategories}
//               onChange={setSelectedCategories}
//               placeholder="Wybierz kategorie..."
//               menuPortalTarget={document.body}  
//               classNamePrefix="rs"      // <-- DODAJ TO
//               styles={{
//                 menuPortal: (base) => ({ ...base, zIndex: 9999 }), // <-- I TO
//               }}
//             />
//           </div>

//             {/* Filtry ceny */}
//             <div className="price-filters flex-shrink-0 d-flex align-items-center gap-2">
//               <div className="form-check form-check-inline mb-0">
//                 <input
//                   className="form-check-input"
//                   type="checkbox"
//                   id="filterFree"
//                   checked={priceFilters.free}
//                   onChange={(e) =>
//                     setPriceFilters((prev) => ({ ...prev, free: e.target.checked }))
//                   }
//                 />
//                 <label className="form-check-label small" htmlFor="filterFree">
//                   🆓 Darmowe
//                 </label>
//               </div>
//               <div className="form-check form-check-inline mb-0">
//                 <input
//                   className="form-check-input"
//                   type="checkbox"
//                   id="filterPaid"
//                   checked={priceFilters.paid}
//                   onChange={(e) =>
//                     setPriceFilters((prev) => ({ ...prev, paid: e.target.checked }))
//                   }
//                 />
//                 <label className="form-check-label small" htmlFor="filterPaid">
//                   💵 Płatne
//                 </label>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>



//       {/* TREŚĆ: lista + mapa */}
//       <div className="flex-grow-1 d-flex flex-column flex-lg-row position-relative" style={{ height: 'calc(100vh - 140px)' }}>
        
//         {/* PRZYCISK POKAŻ / SCHOWAJ (tylko na małych ekranach) */}
//         <div className="toggle-events-btn d-lg-none text-center py-2">
//           <button
//             className="btn btn-primary rounded-pill px-4 py-2 shadow-sm"
//             onClick={() => setShowEventsList((prev) => !prev)}
//           >
//             <i className={`bi ${showEventsList ? 'bi-chevron-up' : 'bi-chevron-down'} me-1`}></i>
//             {showEventsList ? 'Schowaj listę wydarzeń' : 'Pokaż listę wydarzeń'}
//           </button>
//         </div>

//         {/* LISTA EVENTÓW */}
//         <div
//           className={`event-list col-12 col-lg-5 overflow-auto border-end p-3 transition-all ${
//             showEventsList ? 'show' : 'hide'
//           }`}
//           style={{
//             maxHeight:
//             windowWidth < 992
//               ? showEventsList
//                 ? '45vh'
//                 : '0px'
//               : '100%',
//           opacity: windowWidth < 992 ? (showEventsList ? 1 : 0) : 1,
//           transition: 'max-height 0.4s ease, opacity 0.3s ease',
//         }}
//         >
//           {loading && (
//             <div className="gradient-loader">
//               <div className="circle"></div>
//               <p>Ładowanie...</p>
//             </div>
//           )}
//           {!loading && filtered.length === 0 && (
//             <div className="text-center text-secondary my-5">
//               <i className="bi bi-inbox fs-1 mb-3"></i>
//               <p className="mb-0">Brak wydarzeń spełniających kryteria.</p>
//             </div>
//           )}
//           {!loading &&
//             filtered.map((e) => (
//               <div
//                 key={e.id}
//                 id={`event-${e.id}`}
//                 className={`card event-card mb-3 ${selected === e.id ? 'active' : ''}`}
//                 onClick={() => {
//                     handleSelectEvent(e.id);
//                   setSelected(e.id);
//                   setTimeout(() => {
//                     document.getElementById(`event-${e.id}`)?.scrollIntoView({
//                       behavior: 'smooth',
//                       block: 'start',
//                     });
//                   }, 250);
//                 }}
//               >
//                 <div
//                   className="cover"
//                   style={{
//                     backgroundImage: `url("${e.cover}")`,
//                   }}
//                 ></div>

//                 <div className="card-body d-flex flex-column justify-content-between">
//                   <div>
//                     <h5 className="card-title mb-2">{e.title}</h5>

//                     {/* Meta: miejsce, data, cena, zainteresowani */}
//                     <div className="event-meta d-flex flex-wrap align-items-center gap-2 text-secondary small mb-2">
//                       {e.place && (
//                         <div className="meta-item d-flex align-items-center">
//                           <i className="bi bi-geo-alt me-1 text-primary"></i>
//                           <span>{e.place}</span>
//                         </div>
//                       )}
//                       {e.date && (
//                         <div className="meta-item d-flex align-items-center">
//                           <i className="bi bi-calendar-event me-1 text-primary"></i>
//                           <span>{e.date}</span>
//                         </div>
//                       )}
//                       <div className="meta-item d-flex align-items-center">
//                         <i className="bi bi-coin me-1 text-warning"></i>
//                         <span>{e.isFree ? 'Darmowe' : e.price || 'Płatne'}</span>
//                       </div>
//                       {Number.isFinite(e.popularity) && (
//                         <div className="meta-item d-flex align-items-center">
//                           <i className="bi bi-eye me-1 text-info"></i>
//                           <span>{e.popularity}</span>
//                         </div>
//                       )}
//                     </div>

//                     {/* Opis */}
//                     {e.description && expandedEvent !== e.id && (
//                       <p className="small text-muted mb-0">
//                         {e.description.slice(0, 100)}
//                         {e.description.length > 100 && '... '}
//                         <span
//                           className="text-primary fw-semibold cursor-pointer"
//                           onClick={(ev) => {
//                             handleSelectEvent(e.id);
//                             ev.stopPropagation();
//                             setExpandedEvent(e.id);
//                             setTimeout(() => {
//                               document.getElementById(`event-${e.id}`)?.scrollIntoView({
//                                 behavior: 'smooth',
//                                 block: 'start',
//                               });
//                             }, 250);
//                           }}
//                         >
//                           więcej
//                         </span>
//                       </p>
//                     )}

//                     {/* Rozwinięty opis */}
//                     {expandedEvent === e.id && (
//                       <ExpandableSection isOpen={expandedEvent === e.id}>
//                         <div className="expanded-event mt-2">
//                           <p
//                             className="small text-muted"
//                             style={{ whiteSpace: "pre-line", wordBreak: "break-word" }}
//                           >
//                             {e.description}
//                           </p>

//                           {e.organizer && (
//                             <p className="small mb-1">
//                               <i className="bi bi-person-circle me-1 text-secondary"></i>
//                               <strong>Organizator:</strong>{' '}
//                               {e.organizer_link ? (
//                                 <a
//                                   href={e.organizer_link}
//                                   target="_blank"
//                                   rel="noreferrer"
//                                   className="text-decoration-none text-primary"
//                                 >
//                                   {e.organizer}
//                                 </a>
//                               ) : (
//                                 e.organizer
//                               )}
//                             </p>
//                           )}

//                           {e.link && (
//                             <p className="small mb-2">
//                               <i className="bi bi-link-45deg me-1 text-secondary"></i>
//                               <a
//                                 href={e.link}
//                                 target="_blank"
//                                 rel="noreferrer"
//                                 className="text-decoration-none text-primary"
//                               >
//                                 Otwórz wydarzenie
//                               </a>
//                             </p>
//                           )}

//                           <button
//                             className="btn btn-sm btn-outline-secondary rounded-pill"
//                             onClick={(ev) => {
//                               ev.stopPropagation();
//                               setExpandedEvent(null);
//                             }}
//                           >
//                             <i className="bi bi-chevron-up me-1"></i> Zwiń
//                           </button>
//                         </div>
//                       </ExpandableSection>
//                     )}
//                   </div>

//                   {/* Kategorie + zaplanuj */}
//                   <div className="d-flex justify-content-between align-items-center mt-2">
//                     <div className="d-flex flex-wrap gap-1">
//                       {e.primary && (
//                         <span className="badge text-bg-primary text-white px-2 py-1 rounded-pill">
//                           {e.primary}
//                         </span>
//                       )}
//                       {e.tags
//                         .filter((t) => t !== e.primary)
//                         .map((t) => (
//                           <span key={t} className="badge text-bg-light px-2 py-1 rounded-pill">
//                             {t}
//                           </span>
//                         ))}
//                     </div>

//                     <button
//                       className={`btn btn-sm rounded-pill ${
//                         isPlanned(e.id) ? 'btn-success' : 'btn-outline-primary'
//                       }`}
//                       onClick={(ev) => {
//                         ev.stopPropagation();
//                         togglePlan(e.id);
//                       }}
//                     >
//                       <i className={`bi ${isPlanned(e.id) ? 'bi-check2-circle' : 'bi-bookmark-plus'}`}></i>
//                     </button>
//                   </div>
//                 </div>
//               </div>
//             ))}
//         </div>

//         {/* MAPA */}
//         <div className="col-12 col-lg-7 flex-grow-1">
//           <MapContainer className="w-100 h-100 rounded-4 overflow-hidden" center={selectedCoord} zoom={12} scrollWheelZoom>
//             <TileLayer
//               attribution='&copy; OpenStreetMap • &copy; CARTO'
//               url="https://cartodb-basemaps-a.global.ssl.fastly.net/light_all/{z}/{x}/{y}{r}.png"
//             />
//             <MapFly center={selectedCoord} />
//             {markers.map((e) => (
//               <Marker
//                 key={e.id}
//                 position={e.coords}
//                 icon={divIconFor(markerColorByTags(e.tags))}
//                 ref={(ref) => (markerRefs.current[e.id] = ref)}
//                 eventHandlers={{
//                   click: () => handleSelectEvent(e.id),
//                 }}
//               >
//                 <Popup>
//                   <strong>{e.title}</strong>
//                   <br />
//                   {e.place && <>📍 {e.place}<br /></>}
//                   {e.date && <>📅 {e.date}<br /></>}
//                   {e.link && (
//                     <a href={e.link} target="_blank" rel="noreferrer">
//                       Szczegóły
//                     </a>
//                   )}
//                 </Popup>
//               </Marker>
//             ))}
//           </MapContainer>
//         </div>
//       </div>
//     </div>
//   );
// }
function App() {
  return (
    <>
    <Routes>
      <Route path="/" element={<MainPage />} />
      {/* <Route path="/login" element={<Login />} /> */}
      {/* <Route path="/register" element={<Register />} /> */}
      <Route path="/profile" element={<Profile />} />
      <Route path="/profile/settings" element={<AccountSettingsPage />} />
      <Route path="/profile/:id" element={<PublicProfile />} />
      <Route path="/event/:id" element={<EventPage />} />
      {/* <Route path="/create-event" element={<CreateEventModal />} /> */}
      <Route path="/reset-hasla" element={<ResetPasswordRoute />} />
      <Route path="/email-verified" element={<ConfirmMailRoute />} />
      <Route path="/:citySlug" element={<CityRedirect />} />
      <Route path="/:citySlug/:categorySegments" element={<CityRedirect />} />
      <Route path="/o-nas" element={<AboutPage />} />
      {/* <Route path="/regulamin-serwisu" element={<RegulaminSerwisuPage />} /> */}
      <Route
        path="/regulamin-serwisu"
        element={<RedirectToPdf pdfPath="/legal/siedzieje_regulamin_serwisu.pdf" />}
      />
      <Route
        path="/polityka-prywatnosci"
        element={<RedirectToPdf pdfPath="/legal/siedzieje_polityka_prywatnosci.pdf" />}
      />
      
    </Routes>
    <AuthModal/>
    </>
  );
}

export default App;

